module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-schedule"
  }, [_c('div', {
    staticClass: "modal-schedule__overlay"
  }), _c('div', {
    staticClass: "modal-schedule__container"
  }, [_c('iframe', {
    staticClass: "modal-schedule__scheduler",
    attrs: {
      "name": "localmed-iframe-jqbjst0m",
      "src": "https://www.localmed.com/offices/dp3q5k0z36b7qb6_f8ceb04/widget/?chrome=&amp;hidePartnerLogo=true&amp;partnerId=&amp;referringWidgetId=56c3bcd8-12b3-4f2e-95aa-11e2e6405564&amp;scheduling=in_widget&amp;utm_campaign=modal_widget&amp;utm_content=Restoration%2BDental%2BGroup%2B-%2Bwebsite&amp;utm_medium=widget&amp;utm_source=www.restorationdentalgroup.com",
      "frameborder": "0",
      "width": "100%",
      "height": "365"
    }
  }), _c('div', {
    staticClass: "modal-schedule__cross",
    on: {
      "click": function($event) {
        return _vm.$emit("closeScheduleModal")
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50f8c541","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal-schedule/modal-schedule.pug
// module id = 556
// module chunks = 1